import trackedRequests from "./trackedRequests";
import WebConfig from 'middlewares/WebConfig';

export function addRequest(method, uri, payload = "", successCallback, errorCallback, isFetchingCallback, mountedRef) {
  const key = createKey(method, uri, payload);
  if (trackedRequests && trackedRequests[key]) {
    environmentAwareConsoleLog(`Cancelled duplicate request to ${uri}, callback rolled into original request`);
    trackedRequests[key].push({ success: successCallback, error: errorCallback, fetching: isFetchingCallback, mounted: mountedRef });
    return null;
  }
  trackedRequests[key] = [{ success: successCallback, error: errorCallback, fetching: isFetchingCallback, mounted: mountedRef }];
  return key;
}

export function removeRequest(key) {
  if (trackedRequests && trackedRequests[key]) {
    delete trackedRequests[key];
  }
}

export function abortAll() {
  window.stop();
  Object.keys(trackedRequests).forEach((key) => delete trackedRequests[key]);
}

function createKey(method, uri, payload) {
  return `${method.toLowerCase()}${uri.replace(/[^a-zA-Z0-9 ]/g, "")}${hashCode(payload)}`;
}

// https://stackoverflow.com/questions/6122571/simple-non-secure-hash-function-for-javascript
function hashCode(s) {
  let hash = 0;
  if (s === null || s.length === 0) {
    return hash;
  }
  for (let i = 0; i < s.length; i++) {
    let char = s.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}

// returns true if the error was logged in case you want to do something else too
export function environmentAwareConsoleLog(...message) {
  if (WebConfig.environment !== 'production') {
    // eslint-disable-next-line no-console
    console.log(...message);
    return true;
  }
  return false;
}